// eslint-disable-next-line import/prefer-default-export
export const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform);
// TODO: User Agent string is not best practice but we don't really have much alternative.
